export default __webpack_public_path__ + "static/media/gallery5.fc64f6a3.jpg";